export const whitelabelConfig = {
  short: 'Urlaubsguru',
  assetUrl: '/whitelabel/urlaubsguru/',
  storeName: 'Urlaubsguru Online Store',
  company: 'we-are.travel GmbH',
  analyticsId_ua: 'UA-156259931-4', //old ua
  analyticsId: 'G-8YQYSTNPLP', //ga4
  analyticsType: 'gtag', //should be 'gtag', 'ua' or 'both'
  tagManager: {
    id: 'GTM-MH2R56M',
    mode: 'ua', //ua || default (default = ecommerce app+web; ua =  enhanced ecommerce ua)
    brand: 'we-are.travel Urlaubsgutscheine',
  },
  logoHeader:
    'https://assets.urlaubsgutschein.kaufen/whitelabel/urlaubsguru/urlaubsguru-logo.svg',
  logoFooter:
    'https://assets.urlaubsgutschein.kaufen/whitelabel/urlaubsguru/urlaubsguru-logo-white.svg',
  // logoHeader: () => require('@/assets/urlaubsguru-logo.svg'),
  // logoFooter: () => require('@/assets/urlaubsguru-logo-white.svg'),
  isStandalone: false,
  showHeader: false,
  showHeaderLogo: false,
  showFooterLogo: false,
  fixedNavbar: false,
  heroTitle: 'Urlaubsgutscheine',
  hasHeroSubtitle: true,
  heroSubtitle: 'clever & günstig mit Urlaubsgutschein',
  supportMail: 'urlaubsguru@we-are.travel',
  //supportPhone: '+43 732 60 05 36',
  hasHeroAddition: false,
  showPromoNotification: false,
  showReduction: true,
  hasCookieConsent: false,
  hasNewsletterOptin: false,
  heroHomeOnly: true,
  heroImageResolution: {
    xl: {width: 1920, height: 800, crop: 'smart'},
    l: {width: 1200, height: 600, crop: 'smart'},
    m: {width: 1024, height: 500, crop: 'smart'},
    s: {width: 960, height: 300, crop: 'east'},
    xs: {width: 700, height: 200, crop: 'east'},
  },
  hasOfferCta: false,
  hide5sup: true,
  iconUrl: '/img/icons/urlaubsguru/',
  heroInfoText: 'Sparen Sie bis zu 70% für Ihren Kurzurlaub.',
  hasBackToOverviewBtn: true,
  campaignsEnabled: true,
  homepage: {
    advantages: false,
  },
  dealName: 'Top Angebot',
  dealCountdownTitle: 'Angebot endet in',
  dealButton: 'Zum Angebot',
  firstNameBasis: true,
  styleOverride: () =>
    import(
      /* webpackPrefetch: true */

      /* webpackPreload: true */ '@/styles/styles-urlaubsguru.scss'
    ),
}
